import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M7.861 7.73H4.443v12.205h3.418zm8.117 0c-2.385 0-2.795.887-2.99 1.744V7.73H9.57v12.205h3.418V12.96c0-1.131.6-1.744 1.71-1.744 1.08 0 1.708.6 1.708 1.744v6.974h3.418v-6.103c0-3.487-.445-6.102-3.846-6.102Zm-9.826-.872c.944 0 1.71-.78 1.71-1.743s-.766-1.744-1.71-1.744-1.709.78-1.709 1.744c0 .963.765 1.743 1.71 1.743Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }